import { Flex, FlexCenter, FlexColumn, TextLabel } from "@opensea/ui-kit"
import { ArrowRightAlt } from "@opensea/ui-kit/icons"
import { useTranslations } from "use-intl"
import { useSnapshot } from "valtio"
import { Button } from "../../../components/Button"
import { useAddress, useIsConnecting } from "../../../polychain/hooks"
import { FlowState } from "../../../stores/flowStore"
import {
  PaymentMethodOptions,
  PaymentMethodOptionsCard,
  PaymentMethodOptionsWalletOptions,
} from "../PaymentMethodOptions"
import type { PaymentMethod } from "../types"

type Props = {
  paymentMethod: PaymentMethod | undefined
  cardDisabledReason?: string
  setPaymentMethod: (paymentMethod: PaymentMethod | undefined) => void
  onProceedToPayment: () => void
}

export const PaymentMethodStep = ({
  paymentMethod,
  cardDisabledReason,
  setPaymentMethod,
  onProceedToPayment,
}: Props) => {
  const t = useTranslations("wallet.PaymentMethodStep")
  const address = useAddress()
  const isConnecting = useIsConnecting()
  const { flow } = useSnapshot(FlowState)

  return (
    <>
      <FlexCenter className="mb-6 gap-2 text-text-secondary">
        <TextLabel size="xs">{t("paymentMethod")}</TextLabel>
        <ArrowRightAlt size={16} />
        <TextLabel color="text-primary" size="xs">
          {t("selectWallet")}
        </TextLabel>
      </FlexCenter>
      <FlexColumn className="w-full min-w-0">
        <PaymentMethodOptions
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
        >
          {flow?.type === "checkout" && address && (
            <PaymentMethodOptionsCard
              disabledReason={cardDisabledReason}
              selected={paymentMethod === "card"}
            />
          )}
          <PaymentMethodOptionsWalletOptions
            selectedPaymentMethod={paymentMethod}
          />
        </PaymentMethodOptions>

        <Flex className="justify-end">
          <Button
            className="mt-6"
            disabled={!paymentMethod}
            isLoading={isConnecting}
            onClick={onProceedToPayment}
            size="sm"
          >
            {t("save")}
          </Button>
        </Flex>
      </FlexColumn>
    </>
  )
}
